import React, { useEffect, useMemo } from "react";
import { Alert, Box, Paper, Typography } from "@mui/material";
import { M365_OAUTH_CALLBACK_MESSAGE, TEAMS_OAUTH_CALLBACK_MESSAGE, TEAMS_OAUTH_STATE_PREFIX } from "../utils/m365DelegatedOAuth";

let postedCallbackToOpener = false;

const M365OAuthCallback: React.FC = () => {
  const params = useMemo(() => new URLSearchParams(window.location.search), []);
  const code = params.get("code") || "";
  const state = params.get("state") || "";
  const error = params.get("error") || "";
  const errorDescription = params.get("error_description") || "";

  useEffect(() => {
    if (postedCallbackToOpener) return;
    if (!window.opener || window.opener.closed) return;
    postedCallbackToOpener = true;
    window.opener.postMessage(
      {
        type: state.startsWith(TEAMS_OAUTH_STATE_PREFIX) ? TEAMS_OAUTH_CALLBACK_MESSAGE : M365_OAUTH_CALLBACK_MESSAGE,
        code,
        state,
        error,
        errorDescription,
      },
      window.location.origin
    );
    window.setTimeout(() => window.close(), 1200);
  }, [code, error, errorDescription, state]);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "#f8fafc",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 3,
      }}
    >
      <Paper
        elevation={0}
        sx={{
          width: "100%",
          maxWidth: 640,
          p: 4,
          border: "1px solid #E5E7EB",
          borderRadius: "6px",
          bgcolor: "#fff",
        }}
      >
        <Typography sx={{ fontFamily: "var(--theo-font-sans)", fontSize: 24, fontWeight: 700, color: "#111827", mb: 1 }}>
          Microsoft 365 Sign-In
        </Typography>
        {error ? (
          <Alert severity="error" sx={{ fontFamily: "var(--theo-font-sans)" }}>
            {errorDescription || error}
          </Alert>
        ) : (
          <Typography sx={{ fontFamily: "var(--theo-font-sans)", fontSize: 14, color: "#4B5563", lineHeight: 1.6 }}>
            Return to Theo. This window will close automatically.
          </Typography>
        )}
      </Paper>
    </Box>
  );
};

export default M365OAuthCallback;
